module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-1",
    style: (_vm.plano),
    attrs: {
      "id": "clear-message-verification"
    }
  }, [(_vm.$route.name === 'Login') ? _c('login') : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'Login' && _vm.canDisplayLoadAccess) ? _c('main', {
    class: _vm.getTheme + ' flex-1 flex-column ',
    style: (_vm.plano),
    attrs: {
      "id": "app"
    },
    on: {
      "click": _vm.closeBasketMenu
    }
  }, [(_vm.canDisplayLoadAccess) ? _c('appHeader', {
    ref: "header",
    on: {
      "reset": function($event) {
        _vm.resetSearch($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cf"
  }), _vm._v(" "), (_vm.$route.name !== 'Plano' && _vm.$route.name !== 'Configurator') ? _c('div', {
    staticClass: "content flex-1",
    class: [{
      barAdmin: _vm.hasAccessBothAdmin()
    }, {
      withForecastBanner: _vm.getActiveAmountForecast > 0
    }]
  }, [(_vm.$route.name !== 'Login') ? _c('div', {
    class: 'flex-1'
  }, [_c('router-view')], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Plano') ? _c('div', {
    staticClass: "builderContainer flexContainer fd-c ai-s ac-s",
    style: (_vm.plano)
  }, [_c('router-view')], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Configurator') ? _c('div', {
    staticClass: "configWrapper flexContainer fd-r ai-s ac-s"
  }, [_c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('Cookie'), _vm._v(" "), (_vm.getShown) ? _c('CguModal') : _vm._e(), _vm._v(" "), (_vm.canDisplayLoadAccess) ? _c('appFooter') : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8399f25c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 3300
// module chunks = 0